import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MVMTabComponent } from './mvm-tab/mvm-tab.component';
@NgModule({
    declarations: [
        MVMTabComponent
    ],
    imports: [
        CommonModule,
        RouterModule
    ],
    exports: [
        MVMTabComponent
    ]
})

export class MVMTabModule {}
